import { useEffect } from "react";
import { NEW_APP_URL } from "@/config/retired";

export function RetiredBanner() {
  return (
    <div className="bg-amber-100 text-amber-950 text-sm text-center px-4 py-2 border-b border-amber-300">
      Esta es la versión anterior de DoctIA y dejará de estar disponible en pocos días.{" "}
      <a href={NEW_APP_URL} className="font-semibold underline">
        Ir a la nueva versión
      </a>
    </div>
  );
}

/** Account, plan and payment pages live only in the new app. */
export function Moved({ path }: { path: string }) {
  useEffect(() => {
    window.location.replace(`${NEW_APP_URL}${path}`);
  }, [path]);
  return (
    <p className="p-8 text-center text-muted-foreground">
      Esta sección ahora está en{" "}
      <a href={`${NEW_APP_URL}${path}`} className="text-primary underline">
        la nueva versión de DoctIA
      </a>
      .
    </p>
  );
}
